// CSR-1940 — By-policy filter for the Insured Activity Timeline. A dumb
// value/onChange Select so `applyTimelineFilters` stays the single filtering
// truth. Always rendered (layout stability); options key on the structured
// policy id, never a rendered string.

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Policy } from "@shared/schema";

export const ALL_POLICIES = "all";

interface Props {
  policies: Pick<Policy, "id" | "policyNumber">[];
  /** Selected policy id, or `"all"`. */
  value: string;
  onChange: (value: string) => void;
}

export function TimelinePolicyFilter({ policies, value, onChange }: Props) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        className="h-8 w-[150px] cursor-pointer text-xs"
        data-testid="timeline-policy-filter"
        aria-label="Filter by policy"
      >
        <SelectValue placeholder="All policies" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_POLICIES}>All policies</SelectItem>
        {policies.map((p) => (
          <SelectItem key={p.id} value={p.id}>
            {p.policyNumber ? `Policy ${p.policyNumber}` : p.id}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
